import { render, staticRenderFns } from "./EquipmentReadings.vue?vue&type=template&id=36841809&scoped=true&"
import script from "./EquipmentReadings.vue?vue&type=script&lang=js&"
export * from "./EquipmentReadings.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentReadings.vue?vue&type=style&index=0&id=36841809&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36841809",
  null
  
)

export default component.exports